/**
 * @generated SignedSource<<ee98c0ce34f33e3c4f3543efa8bedf8b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueCreateFooter_nativeIssueTable_issues$data = {
  readonly __id: string;
  readonly " $fragmentType": "issueCreateFooter_nativeIssueTable_issues";
};
export type issueCreateFooter_nativeIssueTable_issues$key = {
  readonly " $data"?: issueCreateFooter_nativeIssueTable_issues$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueCreateFooter_nativeIssueTable_issues">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueCreateFooter_nativeIssueTable_issues",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "80e50d59b31e5c90016c84b106f12ad2";

export default node;
